type ConvertMediaToRichTextDocumentWorkflowLike =
  | {
      richTextDocuments?: Array<{ id: string }> | null;
      conversionStatus?: {
        failedAt?: string | null;
        succeededAt?: string | null;
      } | null;
    }
  | null
  | undefined;

/**
 * conversionStatus (the backend workflow node) is the source of truth when
 * present; doc presence is only a fallback for legacy workflows with no
 * WorkflowConnection. The agent path attaches an empty doc up front and
 * streams into it, so "has a document" does not imply "done".
 */
export const isMediaConversionInProgress = (
  convertWorkflow: ConvertMediaToRichTextDocumentWorkflowLike,
): boolean => {
  if (!convertWorkflow) {
    return false;
  }
  const status = convertWorkflow.conversionStatus;
  if (status) {
    return !(status.failedAt || status.succeededAt);
  }
  return !convertWorkflow.richTextDocuments?.length;
};
